import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Icon, IconName} from '../../../libs/shared/ui/src/components/icon/icon';
import {ellipsis} from '../../../libs/shared/ui/src/styles/mixins';
import {useUserTheme} from '../../../libs/shared/ui/src/theme/userThemeProvider';
import {AnswerOrFolderModel} from '../../models/api/answerFolderModel';
import {RAnswer} from '../../models/api/answerModel';

/*
 * Props.
 */

interface SettingsAnswersHeaderTitleProps {
  answerOrFolder?: AnswerOrFolderModel;
  isCreatingAnswer?: boolean;
  isCreatingFolder?: boolean;
}

/*
 * Style.
 */

const StyledTagName = styled.span`
  ${ellipsis()};
  padding-right: 20px;
`;

/*
 * Component.
 */

export const SettingsAnswersHeaderTitle: FC<SettingsAnswersHeaderTitleProps> = (props) => {
  const theme = useUserTheme();
  const {answerOrFolder, isCreatingAnswer, isCreatingFolder} = props;

  if (!answerOrFolder && !isCreatingAnswer && !isCreatingFolder) {
    return <Trans id="settingsmessagetemplates-templates">Message templates</Trans>;
  }

  if (!answerOrFolder && isCreatingAnswer && !isCreatingFolder) {
    return <Trans id="settingsmessagetemplates-addtemplate">Add template</Trans>;
  }

  if (!answerOrFolder && !isCreatingAnswer && isCreatingFolder) {
    return <Trans id="settingsmessagetemplates-addfolder">Add folder</Trans>;
  }

  if (!answerOrFolder) {
    return null;
  }

  const iconName: IconName = RAnswer.is(answerOrFolder) ? 'messageTemplateLarge' : 'folderLarge';

  return (
    <>
      <Icon color={theme.greys.shade70} name={iconName} size={24} />
      <StyledTagName>{answerOrFolder.name}</StyledTagName>
    </>
  );
};
